export const MAX_HOURS = 12;

export const TIMESTAMP = {
    longFormat: "MMMM d, yyyy",
    defaultFormat: "MMMM d",
};
